__turbopack_context__.v({
  "followingContainer": "FollowingView-module-scss-module__Xs41RW__followingContainer",
  "title": "FollowingView-module-scss-module__Xs41RW__title",
});
